import PropTypes from 'prop-types';
import fee from './fee';

export default PropTypes.arrayOf(fee);
